import { clients } from '@digital-commerce/shared-utils'
import createDigitalCommerceCartClient from '../clients/bff'

const bffClient = createDigitalCommerceCartClient(clients.bff)

const useLog = () => {
  const logContent = async (content) => {
    try {
      await bffClient.log(content)
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Failed to log', err)
    }
  }

  return {
    logContent
  }
}

export default useLog
